export default __webpack_public_path__ + "static/media/slider-2.8e40715d.jfif";